import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle, IconButton, List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText, Typography
} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {useContext, useEffect, useState} from "react";
import {BoardContext} from "../BoardContextProvider";
import {useAsync2, useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../api/API";
import {User} from "../../../api/Users";
import {AutoComplete} from "../../project/shopdrawing/openings/AutoComplete";
import {BoardWatcher} from "../../../api/Tasks2";
import {Delete} from "@mui/icons-material";

export function BoardSettings(props: {
    onClose(): void;
}) {
    const ctx = useContext(BoardContext);
    const w = useAsync2((input) => api.tasks2.getBoardWatchers(input),
        {board: ctx.board.id},
        [ctx.board.id]);

    const [watchers, setWatchers] = useState<BoardWatcher[]>([]);

    const wList = w.asList;
    useEffect(() => {
        setWatchers(wList);
    }, [wList])

    const updateWatchers = useAsyncAction(async (input) => {
        const list = await api.tasks2.updateBoardWatchers(input)
        setWatchers(list);
    }, []);

    return (
        <Dialog2 open onClose={props.onClose}>
            <DialogTitle>
                '{ctx.board.title}' Settings
            </DialogTitle>
            <DialogContent>
                {w.LoadingOrErrorElement}
                <b>Watchers</b>
                <Typography variant="body1">
                    Watchers will receive notifications when tasks are added to this board.
                </Typography>
                <List dense>
                {watchers.map(itm => (
                    <ListItem>
                        <ListItemText primary={itm.usrName} />
                        <ListItemSecondaryAction>
                            <IconButton onClick={() => updateWatchers.callback([Object.assign({}, itm, {
                                archived: true,
                            })])}>
                                <Delete/>
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
                </List>
                {updateWatchers.LoadingElement}
                <div>
                    <AutoComplete<User>
                        value={null}
                        onSelect={(input) => {
                            updateWatchers.callback([{
                                board: ctx.board.id,
                                usr: input.id,
                            }])
                        }}
                        search={input =>
                            api.users.list({search: input, offset: 0}).
                            then(r => r.data)
                        }
                        equals={(a, b) => a.id === b.id}
                        makeLabel={v => v.name}
                        placeholder="Add watcher"
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onClose()}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}